import { Button } from '@/components/ui/Button';
import { Column } from '@tanstack/react-table';
import {
  ArrowDownWideNarrow,
  ArrowUpDown,
  ArrowUpNarrowWide,
} from 'lucide-react';
import { ReactNode } from 'react';

export function createSortingButton<T>(
  column: Column<T, unknown>,
  columnName: string,
): ReactNode {
  return (
    <Button
      variant="ghost"
      className="has-[>svg]:px-0"
      onClick={() => column.toggleSorting()}
    >
      {columnName}
      {column.getIsSorted() === 'asc' ? (
        <ArrowUpNarrowWide className="h-4 w-4" />
      ) : column.getIsSorted() === 'desc' ? (
        <ArrowDownWideNarrow className="h-4 w-4" />
      ) : (
        <ArrowUpDown className="h-4 w-4" />
      )}
    </Button>
  );
}
